import React from 'react';
import { InfluencerUploadResultModel } from '../../../Models/InfluencerUploadResultModel';
import { useInputStyles, useResultStyles } from '../../../shared/components/UploadStyles';
import { StatusResult } from '../../../shared/enum/StatusResult';
import SucessImg from '../../../assets/sucess.svg';
import AlertImg from '../../../assets/alert.svg';
import ErrorImg from '../../../assets/error.svg';
import { Button, Grid, Typography } from '@material-ui/core';
import CustomAccordion from '../../../shared/components/CustomAccordion';
interface IUploadResultProps {
    result: InfluencerUploadResultModel,
    nameFile: string,
    hasHistoryButton: boolean,
    onClickHistory: () => void,
    onClickNewUpload: () => void,
    onClickStartClassification: () => void
}
let checkTodosInfluencerInseridos = false;

export function InfluencerUploadResult({ result, nameFile, hasHistoryButton, onClickHistory, onClickNewUpload, onClickStartClassification }: IUploadResultProps) {
    const classes = useResultStyles();
    const styles = useInputStyles();
    const QuotaLimit: any = sessionStorage.getItem('ignoreQuotaLimit') ? sessionStorage.getItem('ignoreQuotaLimit') : 'false'; 

    function getTitle(): string {
        if (result.status == StatusResult.ERROR) {
            if (result.property == 'SpreadsheetAccess')
                return 'Não foi possível acessar a planilha inserida.';

            return 'Ocorreu um problema com o processamento da sua planilha.';
        } else {
            if (result.quantityInserted > 0)
                return 'Sua planilha foi processada com sucesso!';
            else
                return 'Nenhum novo dado foi importado.';
        }
    }

    function ignoreQuotaLimit() {
        sessionStorage.setItem('ignoreQuotaLimit', 'true');
        onClickNewUpload();
    }

    function getSubTitle() {
        checkTodosInfluencerInseridos = false;
        if (result.status == StatusResult.ERROR) {
            switch (result.property) {
                case 'SpreadsheetAccess':
                    return 'Não foi possível abrir a planilha inserida para realizar o processamento de dados. Por gentiliza, revise a planilha e realize um novo upload.';
                default:
                    return 'Não conseguimos processar alguns campos da sua planilha. Por gentiliza, revise a planilha e realize um novo upload.';
            }
        } else {
            if (!result.quotaOverflow) {
                if (result.quantityInserted > 0) {
                    if (result.quantityDuplicated > 0) {
                        if (result.quantityDuplicated == 1) {
                            return (
                                <div style={{ width: 600 }}>
                                    <div className={styles.textStart}>{`${result.quantityInserted.toString()} de ${result.quantityTotal.toString()} Submetidos com sucesso.`}</div>
                                    <div className={styles.textStart}>{`${result.quantityDuplicated.toString()} Perfil duplicado, consulte o dashboard.`}</div>
                                    <br />
                                    <div className={styles.textStart}>{'controle de cotas:'}</div>
                                    <div className={styles.textStart}>{`• Cota mensal da marca: ${result.quotasQuantity.toString()}`}</div>
                                    <div className={styles.textStart}>{`• Quantidade consumida: ${result.insertedQuotas + result.quotasInput}`}</div>
                                    <div className={styles.textStart}>{`• Quantidade restante:  ${result.quotasQuantity - (result.insertedQuotas + result.quotasInput)}`}</div>
                                </div>
                            );
                        }

                        return (
                            <div style={{ width: 600 }}>
                                <div className={styles.textStart}>{`${result.quantityInserted.toString()} de ${result.quantityTotal.toString()} Submetidos com sucesso.`}</div>
                                <div className={styles.textStart}>{`${result.quantityDuplicated.toString()} Perfis duplicados, consultem o dashboard.`}</div>
                                <br />
                                <div className={styles.textStart}>{'controle de cotas:'}</div>
                                <div className={styles.textStart}>{`• Cota mensal da marca: ${result.quotasQuantity.toString()}`}</div>
                                <div className={styles.textStart}>{`• Quantidade consumida: ${result.insertedQuotas + result.quotasInput}`}</div>
                                <div className={styles.textStart}>{`• Quantidade restante:  ${result.quotasQuantity - (result.insertedQuotas + result.quotasInput)}`}</div>
                            </div>
                        );
                    } else
                        return (
                            <div style={{ width: 600 }}>
                                <div className={styles.textStart}>{`Tudo pronto! Todos os ${result.quantityInserted.toString()} influenciadores foram importados.`}</div>
                                <div className={styles.textStart}>{`• Cota mensal da marca: ${result.quotasQuantity.toString()}`}</div>
                                <div className={styles.textStart}>{`• Quantidade consumida: ${result.insertedQuotas + result.quotasInput}`}</div>
                                <div className={styles.textStart}>{`• Quantidade restante:  ${result.quotasQuantity - (result.insertedQuotas + result.quotasInput)}`}</div>
                            </div>
                        );
                }
                else {
                    checkTodosInfluencerInseridos = true;
                    return 'Todos os influenciadores enviados já foram analisados, portanto, nenhum dado foi importado. Consulte o Dashboard.';
                }
            } else {
                return (
                    <div style={{ width: 600 }}>
                        <div className={styles.textStart}>{`• Cota mensal da marca: ${result.quotasQuantity.toString()}`}</div>
                        <div className={styles.textStart}>{`• Quantidade consumida: ${result.insertedQuotas + result.quotasInput}`}</div>
                        <div className={styles.textStart}>{`• Quantidade restante:  ${result.quotasQuantity - (result.insertedQuotas + result.quotasInput)}`}</div>
                    </div>
                );
            }
        }
    }

    function getIcon() {
        if (result.status == StatusResult.ERROR) {
            return (
                <div className={classes.icon}>
                    <img src={ErrorImg} alt="" />
                </div>
            );
        } else {
            if (result.quantityInserted > 0)
                return (
                    <div className={classes.icon}>
                        <img src={SucessImg} alt="" />
                    </div>
                );
            else
                return (
                    <div className={classes.icon}>
                        <img src={AlertImg} alt="" />
                    </div>
                );
        }
    }


    return (
        <Grid
            container
            direction="column"
            justify="center"
            alignItems="center">
            <Typography variant="h4" className={classes.title}>
                {getTitle()}
            </Typography>
            <Typography variant="body1" className={classes.item}>
                {getSubTitle()}
            </Typography>
            {(result.quantityDuplicated > 0 && result.registeredInfluencersMessage) && (
                <div className={classes.item}>
                    <CustomAccordion messages={result?.registeredInfluencersMessage} title={'Influenciadores Já Cadastrados!'} />
                </div>
            )}

            {(result.status == StatusResult.ERROR) && (
                <div className={classes.item}>
                    <CustomAccordion messages={result.message} title={result.title} />
                </div>
            )}
            {getIcon()}
            <Typography variant="subtitle1" className={classes.nameFile}>
                {nameFile}
            </Typography>
            {/* {result.quantityInserted > 0 && (
                <Button
                    size="large"
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    onClick={onClickStartClassification}>
                    INICIAR CLASSIFICAÇÃO
                </Button>
            )} */}
            {/* {result.quantityInserted == 0 && hasHistoryButton && (
                <Button
                    size="large"
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    onClick={onClickHistory}>
                    VERIFICAR HISTÓRICO DE PLANILHAS
                </Button>
            )} */}
            {(result.quantityInserted == 0 && result.status != StatusResult.ERROR && !checkTodosInfluencerInseridos) && (
                <Typography variant="body1" className={classes.item}>
                    Se não quiser ultrapassar o limite da cota, volte para a “home” e realize a submissão de uma nova planilha.
                </Typography>
            )}

            {(result.quantityInserted == 0 && result.status != StatusResult.ERROR && !checkTodosInfluencerInseridos) && (<Button
                size="large"
                // variant="outlined"
                disabled={QuotaLimit == 'false' ? false : true}
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={ignoreQuotaLimit}>
                Ignorar limites e fazer upload
            </Button>)}

            {(result.quantityInserted > 0 || result.status == StatusResult.ERROR || checkTodosInfluencerInseridos) && (<Button
                size="large"
                // variant="outlined"
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={onClickNewUpload}>
                FAZER UPLOAD DE NOVA PLANILHA
            </Button>)}
        </Grid>
    );
}